module.exports = __webpack_public_path__ + "img/188.43d759e3.png";